import {
    GridColumnMenuFilter,
    GridColumnMenuCheckboxFilter,
    GridColumnMenuProps,
    GridColumnMenuFilterUIProps,
} from '@progress/kendo-react-grid'

const filterOperator = {
    text: [
        { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
        { text: 'grid.filterEqOperator', operator: 'eq' },
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
        { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
        { text: 'grid.filterIsNullOperator', operator: 'isnull' },
        { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
        { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
        { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' },
    ],
    numeric: [
        { text: 'grid.filterEqOperator', operator: 'eq' },
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterGteOperator', operator: 'gte' },
        { text: 'grid.filterGtOperator', operator: 'gt' },
        { text: 'grid.filterLteOperator', operator: 'lte' },
        { text: 'grid.filterLtOperator', operator: 'lt' },
        { text: 'grid.filterIsNullOperator', operator: 'isnull' },
        { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
    ],
    date: [
        { text: 'grid.filterEqOperator', operator: 'eq' },
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
        { text: 'grid.filterAfterOperator', operator: 'gt' },
        { text: 'grid.filterBeforeOperator', operator: 'lt' },
        { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
        { text: 'grid.filterIsNullOperator', operator: 'isnull' },
        { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
    ],
    boolean: [{ text: 'grid.filterEqOperator', operator: 'eq' }],
}

const filterOperatorCompany = {
    text: [{ text: 'grid.filterNotContainsOperator', operator: 'contain' }],
    numeric: [
        { text: 'grid.filterEqOperator', operator: 'eq' },
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterGteOperator', operator: 'gte' },
        { text: 'grid.filterGtOperator', operator: 'gt' },
        { text: 'grid.filterLteOperator', operator: 'lte' },
        { text: 'grid.filterLtOperator', operator: 'lt' },
        { text: 'grid.filterIsNullOperator', operator: 'isnull' },
        { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
    ],
    date: [
        { text: 'grid.filterEqOperator', operator: 'eq' },
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
        { text: 'grid.filterAfterOperator', operator: 'gt' },
        { text: 'grid.filterBeforeOperator', operator: 'lt' },
        { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
        { text: 'grid.filterIsNullOperator', operator: 'isnull' },
        { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
    ],
    boolean: [{ text: 'grid.filterEqOperator', operator: 'eq' }],
}
export const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuFilter {...props} expanded={true} hideSecondFilter={true} />
        </div>
    )
}

export const ColumnMenuNumericBiggerThan = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuFilter
                {...props}
                expanded={true}
                filterOperators={filterOperator}
                hideSecondFilter={true}
            />
        </div>
    )
}

export const ColumnMenuCheckbox = (
    props: GridColumnMenuProps,
    data: ARAgingGridInvoice[],
    property: keyof ARAgingGridInvoice
) => {
    data.sort((a, b) => {
        const valueA = a[property]
        const valueB = b[property]

        if (typeof valueA === 'string' && typeof valueB === 'string') {
            return valueA.localeCompare(valueB)
        } else if (typeof valueA === 'number' && typeof valueB === 'number') {
            return valueA - valueB
        } else if (valueA instanceof Date && valueB instanceof Date) {
            return valueA.getTime() - valueB.getTime()
        } else {
            // Handle other cases or throw an error if needed
            return 0
        }
    })
    return (
        <div>
            <GridColumnMenuCheckboxFilter
                {...props}
                data={data}
                expanded={true}
                filterOperators={filterOperatorCompany}
                searchBoxFilterOperator={'contains'}
            />
        </div>
    )
}

const InputFilterCell = (props: GridColumnMenuFilterUIProps) => {
    const onChange = (event: any) => {
        const value = event.target.value
        const { firstFilterProps } = props
        firstFilterProps.onChange({
            value: value,
            operator: 'contains',
            syntheticEvent: event.nativeEvent,
        })
    }

    const { firstFilterProps } = props
    const value = firstFilterProps.value
    return (
        <div style={{ textAlign: 'center' }}>
            <input name="Filter" type="text" defaultValue={value} onChange={(e) => onChange(e)} />
        </div>
    )
}

export const ColumnInputFilterMenu = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuFilter
                {...props}
                expanded={true}
                hideSecondFilter={true}
                filterUI={InputFilterCell}
            />
        </div>
    )
}
